import { post } from '@alltrails/core/utils/post';

export const reportList = (listId: string, reason: string) => post(`/api/alltrails/lists/${listId}/report`, { reason });

export const reportMap = (mapId: string, reason: string) => post(`/api/alltrails/maps/${mapId}/report`, { reason });

export const reportPhoto = (photoId: string, reason: string) => post(`/api/alltrails/photos/${photoId}/report`, { reason });

export const reportTrailReview = (trailId: string, trailReviewId: string, reason: any) =>
  post(`/api/alltrails/trails/${trailId}/reviews/${trailReviewId}/report`, { reason });

export const reportUserRequest = (userId: string, reason: string) => post(`/api/alltrails/users/${userId}/report`, { reason });

export const reportFeedComment = (postId: string, commentId: string, reason: string) =>
  post(`/api/alltrails/community/blazes/v0/posts/${postId}/comments/${commentId}/report`, { reason });
